import './App.css';
import './App.scss';
import './responsive.scss';
// import 'semantic-ui-css/semantic.min.css'
// import { BrowserRouter } from 'react-router-dom';

import React from 'react';
import Router from './router';
import { Helmet } from 'react-helmet';

function App() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'EACIIT',
    'url': 'https://eaciit.com',
    'logo': 'https://eaciit.com/eaciit-logo.png',
    'description': 'Data Harmonization & Business AI Platform',
    'foundingDate': '2013',
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+1-XXX-XXX-XXXX',
      'contactType': 'Customer Support'
    },
    'sameAs': [
      'https://twitter.com/eaciit',
      'https://linkedin.com/company/eaciit',
      'https://facebook.com/eaciit'
    ]
  };
  return (
    <>
      <Helmet>
        <title>Eaciit - Enhancing Enterprise Value</title>
        <meta name="description" content="Data Harmonization & Business AI Platform · Scalable and modular architecture · No limitations on data size, structure, users " />
        <meta name="keywords" content="EPMTech, EPM Tech, Digital EPM, EPM, AI in EPM, AI EPM, AI, Data Harmonization, Data Integration, AI efficiencies, Unified Data, Connected Data, Data Integration, KPI Management, KPI Improvement, Collaboration, Next gen BI, Latest BI, New BI, S&OP, Sales and Operations Planning, Financial Planning, Demand Forecasting, Sales Forecasting, Free Cash Flow, FCF, FCF Optimization, EPM Optimization, Budgeting, Reporting, Financial Consolidation, Group Consolidation" />
        <meta property="og:title" content="Eaciit - Enhancing Enterprise Value" />
        <meta property="og:description" content="Data Harmonization & Business AI Platform · Scalable and modular architecture · No limitations on data size, structure, users" />
        <meta property="og:image" content="public/favicon.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <canonical href="https://eaciit.com" />

         {/* Structured Data */}
         <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div className='App'>
        <Router />
        <div className="navigation__scrim"></div>
      </div>
    </>
  );
}

export default App;
